import loadable from "@loadable/component"

const Footer = loadable(() => import("./Footer"))
const Topbar = loadable(() => import("./Topbar"))

export {
    Footer,
    Topbar
}
